<template>
  <div class="relative">
    <template v-if="canRejoinGame">
      <rejoin-game />
    </template>

    <template v-else>
      <your-turn-banner />
      <div class="column-container" >
        <div class="column">
          <game-board />
          <bonus-reference-card />
          <sound-effects />
        </div>

        <div class="column">
          <new-company-section />
          <current-player-section />
          <merger-section />
          <all-players />
          <stocks-available />
          <purchase-stocks />
        </div>
      </div>

      <complete-turn />
    </template>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GameBoard from "@/components/GameBoard";
import CurrentPlayerSection from "@/components/board/CurrentPlayerSection";
import AllPlayers from "@/components/AllPlayers";
import {NS_GAME_STATE} from "@/store/constants";
import YourTurnBanner from '@/components/YourTurnBanner';
import StocksAvailable from "@/components/board/StocksAvailable";
import PurchaseStocks from "@/components/board/PurchaseStocks";
import CompleteTurn from "@/components/CompleteTurn";
import RejoinGame from "@/components/RejoinGame";
import NewCompanySection from "@/components/board/NewCompanySection";
import MergerSection from "@/components/board/MergerSection";
import LogRocket from 'logrocket';
import BonusReferenceCard from "@/components/board/BonusReferenceCard";
import SoundEffects from "@/components/board/SoundEffects";

export default {
  name: 'GameLayout',
  components: {
    SoundEffects,
    BonusReferenceCard,
    MergerSection,
    NewCompanySection,
    RejoinGame,
    CompleteTurn,
    PurchaseStocks,
    StocksAvailable,
    AllPlayers,
    CurrentPlayerSection,
    GameBoard,
    YourTurnBanner
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'canRejoinGame',
      'localPlayer',
      'gameId',
    ]),
  },

  watch: {
    localPlayer(localPlayer) {
      if (localPlayer.id) {
        LogRocket.identify(localPlayer.id, {
          name: localPlayer.name,
          email: this.gameId,
        })
      }
    }
  }
}
</script>

<style scoped>
@media screen and (min-width: 1250px) {
  .column-container {
    display: flex;
    margin-left: -20px;
  }

  .column{
    margin-left: 20px;
    border: 1px solid #0000001f;
    box-shadow: 5px 5px 5px #00000030;
    border-radius: 5px;
  }
}
</style>

